enum UserRole {
  // original Wheel Screener roles
  PUBLIC = '',
  FREE = 'free',
  PREMIUM = 'premium', // legacy, to be converted to PREMIUM_MONTHLY
  LIFETIME = 'lifetime', // legacy, to be converted to PREMIUM_LIFETIME
  STARTER_LIFETIME = 'starter-lifetime',
  STARTER_MONTHLY = 'starter-monthly',
  PREMIUM_LIFETIME = 'premium-lifetime',
  PREMIUM_MONTHLY = 'premium-monthly',
  // new roles for LEAPS Screener
  STARTER_LIFETIME_LEAPS = 'starter-lifetime-leaps',
  STARTER_MONTHLY_LEAPS = 'starter-monthly-leaps',
  PREMIUM_LIFETIME_LEAPS = 'premium-lifetime-leaps',
  PREMIUM_MONTHLY_LEAPS = 'premium-monthly-leaps',
  // new roles for Wheel Screener - EU
  PREMIUM_LIFETIME_EU = 'premium-lifetime-eu',
  PREMIUM_MONTHLY_EU = 'premium-monthly-eu',
  STARTER_LIFETIME_EU = 'starter-lifetime-eu',
  STARTER_MONTHLY_EU = 'starter-monthly-eu'
}
export default UserRole

export const isPremium = (userState: UserRole) => {
  return userState === UserRole.PREMIUM ||
    userState === UserRole.PREMIUM_LIFETIME ||
    userState === UserRole.PREMIUM_MONTHLY ||
    userState === UserRole.PREMIUM_LIFETIME_LEAPS ||
    userState === UserRole.PREMIUM_MONTHLY_LEAPS ||
    userState === UserRole.PREMIUM_LIFETIME_EU ||
    userState === UserRole.PREMIUM_MONTHLY_EU
}

export const isStarter = (userState: UserRole) => {
  return userState === UserRole.STARTER_LIFETIME ||
    userState === UserRole.STARTER_MONTHLY ||
    userState === UserRole.STARTER_LIFETIME_EU ||
    userState === UserRole.STARTER_MONTHLY_EU
}
